import { useTheme } from "../contexts/ThemeContext";
import { t as defaults } from "@realtyflows/ui";

/**
 * BrandStripe — 3px colored line shown across the top of the app header.
 *
 * V2 ADR-003 Phase 4.3 — first consumer of `useTheme()`. Renders only
 * when the active portal has a non-default brand primary color, so the
 * personal portal (and team portals without branding configured) stay
 * visually clean.
 *
 * The pattern: read tokens via `useTheme()` instead of importing `t`
 * directly. Other components migrate over time. This one's tiny and
 * isolates the new wiring — easy to roll back if the context plumbing
 * misbehaves in any environment.
 */
export default function BrandStripe() {
  const theme = useTheme();
  // No stripe when the active portal uses the default gold — would just
  // look like a decorative line, not a brand cue.
  if (!theme.gold || theme.gold === defaults.gold) return null;
  return (
    <div
      role="presentation"
      style={{ height: 3, background: theme.gold, flexShrink: 0 }}
    />
  );
}
